import {Button} from 'react-bootstrap'
import {INodeIdentities} from '../../../../graphql/types/usersTypes'
import {AddValidation} from './AddValidation'

interface IViewOne {
  info: INodeIdentities
  refetch: () => void
  onBack: () => void
}

export const ViewOneValidation: React.FC<IViewOne> = ({info, onBack, refetch}) => {
  return (
    <div>
      <header className='d-flex flex-column flex-md-row align-items-md-center align-items-start justify-content-between'>
        <div className='d-flex align-items-center'>
          <button className='btn-reset btn-link m-0' onClick={onBack}>
            <i className='bi bi-chevron-left fs-1' style={{color: 'inherit'}} />
          </button>
          <h6 className='m-0 p-0 fs-2'>
            {info.firstName} {info.firstSurname}
          </h6>
        </div>
        <div className='d-flex align-items-center gap-3'>
          <Button
            variant='dark'
            disabled={info.status !== 'ANULADO' && info.status !== 'EXITOSA'}
            size='sm'
          >
            Solicitar una url
          </Button>
          <Button
            variant='warning'
            disabled={info.status !== 'ANULADO' && info.status !== 'EXITOSA'}
            size='sm'
          >
            Anular
          </Button>
        </div>
      </header>
      <div className='mt-5'>
        <AddValidation id={info.id} onToggleSubTab={onBack} refetch={refetch} dataPrev={info} />
      </div>
    </div>
  )
}
